import { assertUnreachable } from '../../helpers/TypescriptHelpers';
import { IContentAndLuidInfo } from '../../mappers/DatabaseAndTableMapper';
import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../services/RestApiService';
import { TaggableCatalogTypes, TaggableCatalogTypesRestApiVersion as TaggableCatalogTypesRestApiVersion, Tags } from './CatalogContentTags';

export type GetCatalogContentTagsParam = Pick<IContentAndLuidInfo, 'luid'> & TaggableCatalogTypes ;

type GetTagsForDatabaseResponse = {
  readonly database: Tags;
};

export async function getCatalogContentTags(item: GetCatalogContentTagsParam): Promise<ReadonlyArray<string>> {
  switch (item.contentType) {
    case 'database':
      return getDatabaseTags(item);
    case 'table':
      return getTableTags(item);
    default:
      assertUnreachable(item.contentType);
  }
}

async function getDatabaseTags(item: GetCatalogContentTagsParam): Promise<ReadonlyArray<string>> {
  const config: JsonRestApiRequestConfig = {
    restApiVersion: TaggableCatalogTypesRestApiVersion,
    serverWideRequest: false,
    httpMethod: 'GET',
    endpoint: `databases/${item.luid}`,
  };

  const response = await makeJsonRestApiRequest<{}, GetTagsForDatabaseResponse>({ config, request: {} });
  return response.database.tags.tag.map(t => t.label);
}

type GetTagsForTableResponse = {
  readonly table: Tags;
};

async function getTableTags(item: GetCatalogContentTagsParam): Promise<ReadonlyArray<string>> {
  const config: JsonRestApiRequestConfig = {
    restApiVersion: TaggableCatalogTypesRestApiVersion,
    serverWideRequest: false,
    httpMethod: 'GET',
    endpoint: `tables/${item.luid}`,
  };

  const response = await makeJsonRestApiRequest<{}, GetTagsForTableResponse>({ config, request: {} });
  return response.table.tags.tag.map(t => t.label);
}
